<template>
    <div class="payment__form">
        <form
            v-if="
                state.currentView == 'MOMO_TANZANIA_INIT_VIEW' &&
                    state.processing != true
            "
            @submit.prevent="checkPhoneAndNetwork"
        >
            <h5
                class="container__col-md-12 container__col-sm-12 payment__instruction"
            >
                {{$t("mm.init.instruction")}}
            </h5>

            <primary-select
                class="container__col-md-12 container__col-sm-12"
                title="CHOOSE NETWORK"
                description-text="Click here to choose"
                @value-change="network = $event"
                :options="state.networks"
                :defaultValue="state.defaultNetwork"
                :isRequired="getValueFromPath(state, 'inputs.network.required') || true"
                inputName="network"
            />

            <primary-input
                :title="$t('mm.input.phone')"
                type="tel"
                class="container__col-md-12 container__col-sm-12"
                prefix-image="smart-phone"
                placeholder="255123456789"
                @value-change="telephone = $event"
                :defaultValue="getValueFromPath(state, 'inputs.phone.value') || null"
                :isRequired="getValueFromPath(state, 'inputs.phone.required') || true"
                inputName="phone"
                :number-only="true"
            />
            <PrimaryButton
                :content="
                    [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                        .filter(Boolean)
                        .join(' ')
                "
                type="submit"
                :disabled="hasCompletedFields === false"
            />
        </form>
        <div
            v-else-if="
                state.currentView == 'REDIRECT_VIEW' && state.processing != true
            "
        >
            <RedirectView
                @next="Next"
            />
        </div>
        <div
            v-else-if="
                checkoutData.view.current == 'MOMO_TANZANIA_CONFIRM_VIEW' &&
                    checkoutData.processing != true
            "
        >
            <h5
                class="container__col-md-12 container__col-sm-12 payment__instruction"
            >
                {{$t("mm.notification.message")}}
            </h5>
            <div class="loader-container">
                <div class="loader-wrapper">
                    <div class="loader-icon"></div>
                </div>
            </div>
            <p class="payment__instruction--refresh">{{$t("ui.transaction.refresh")}}.</p>
        </div>
    </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { injectStore, mapState } from "redux-vuex";
import { ref, onBeforeUnmount, watch, computed } from "vue";
import { getValueFromPath } from "@/support/helpers";
import PrimarySelect from "@/components/form/base-select";
import PrimaryButton from "@/components/form/base-button";
import PrimaryInput from "@/components/form/base-input";
import RedirectView from "@/components/common/redirect-view";
import { isValidPhoneNumber } from "../../support/helpers";

export default {
    name: "MobileMoneyTanzania",
    components: {
        PrimaryInput,
        PrimaryButton,
        RedirectView,
        PrimarySelect,
    },
    setup(_, { emit }) {
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const telephone = ref("");
        const network = ref("");
        const transactionSuccessful = ref(false);
        const momoError = ref(false);
        const errorMessage = ref("");
        const { t } = useI18n();

        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        const hasCompletedFields = computed(() => {
            let completed = false;
            if (telephone.value && network.value) {
                completed = true;
            }
            return completed;
        });

        function checkPhoneAndNetwork() {
            if (telephone.value && network.value) { 
                let trimmedPhoneNumber = telephone.value.replace(/\s/g, "").replace(/[()]/g, "");

                if (isValidPhoneNumber(trimmedPhoneNumber)) {
                    momoError.value = `true-${new Date().getTime()}`;
                    errorMessage.value = "";
                    telephone.value = trimmedPhoneNumber;
                    step2();
                } 
                else {
                    momoError.value = `true-${new Date().getTime()}`;
                    errorMessage.value = t("mm.invalid.phonenumber");
                }
            }
        }

        function step2() {
            const data = { phone: telephone.value, network: network.value };
            checkoutData.value.view.context.$actions.update(data);
            Next();
        }
        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }

        watch(network, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                checkoutData.value.view.context.$actions.update({ network: newVal });
            }
        });

        watch(momoError, (newVal, OldVal) => {
            if (newVal !== OldVal) {
                emit("momo-error", errorMessage.value);
            }
        });

        watch(() => checkoutData.value, (newData) => {
            if (newData) {
                momoError.value = false;
            }
        });

        onBeforeUnmount(() => {
            subscription();
        });

        return {
            state: mapState({
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
                amount: (state) => getValueFromPath(state, "amount") || null,
                error: (state) => getValueFromPath(state, "error") || null,
                processing: (state) => getValueFromPath(state, "processing") || false,
                defaultNetwork: (state) =>
                    getValueFromPath(state, "view.context.inputs.network.value"),
                networks: (state) =>
                    getValueFromPath(state, "view.context.inputs.network.options") || [],
                inputs: (state) => getValueFromPath(state, "view.context.inputs") || {},
                currentView: (state) => getValueFromPath(state, "view.current") || null,
            }),
            checkoutData,
            getValueFromPath,
            telephone,
            network,
            transactionSuccessful,
            checkPhoneAndNetwork,
            hasCompletedFields,
            step2,
            Next,
        };
    },
};
</script>

<style scoped>
</style>